module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('montana-map', {
    attrs: {
      "mapFile": "mt.counties.json",
      "dataFile": "mt_load.csv",
      "res": "Lake Koocanusa",
      "resFile": "mt.json",
      "whichState": "MT"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "MT"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "mt.counties.json",
      "centersFile": "mt_centers.json",
      "dataFile": "mt-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52934c7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Montana.vue
// module id = 374
// module chunks = 1